import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NewAssetView from "../NewAssetView";
import WizardStepDialog from "./WizardStepDialog";
import { LOCATION_SNAPSHOT_ADD_ITEM_STEPS, getLocationSnapshotAddItemStepMeta } from "../../steps";

const { NEW } = LOCATION_SNAPSHOT_ADD_ITEM_STEPS;

export default function NewAssetStepDialog({
  open,
  onClose,
  settings,
  activeProjects,
  loadingProjects,
  creatingAsset,
  selectedProjectId,
  onSelectProject,
  onOpenCreateProject,
  quantity,
  onQuantityChange,
  onCreateItem,
  onBack,
}) {
  const { step, steps } = getLocationSnapshotAddItemStepMeta(NEW);
  const canCreate = selectedProjectId && quantity >= 1;

  return (
    <WizardStepDialog
      open={open}
      title="Add New Inventory"
      onClose={onClose}
      step={step}
      steps={steps}
      actions={
        <Box display="flex" gap={1} justifyContent="flex-end">
          <Button variant="outlined" onClick={onBack} disabled={creatingAsset}>
            Back
          </Button>
          <Button
            variant="contained"
            onClick={onCreateItem}
            disabled={!canCreate || creatingAsset}
          >
            Create Item
          </Button>
        </Box>
      }
    >
      <NewAssetView
        settings={settings}
        activeProjects={activeProjects}
        loadingProjects={loadingProjects}
        creatingAsset={creatingAsset}
        selectedProjectId={selectedProjectId}
        onSelectProject={onSelectProject}
        onOpenCreateProject={onOpenCreateProject}
        quantity={quantity}
        onQuantityChange={onQuantityChange}
      />
    </WizardStepDialog>
  );
}
